/*
 * 功能名称: 人员职级职等关系
 * 创 建 人: 张敬磊
 * 日    期: 2025年9月4日
 */
import { NewviewOaBaseApi } from './NewviewOaBaseApi'

export class StaffStandardRelationApi extends NewviewOaBaseApi {
  public get ControllerName(): any {
    return 'staff-standard-relation'
  }
}